export default "__VITE_ASSET__02ba0d3d__"